import http from "./http-common";
import Crypto from "./Crypto";
import { getServidor } from "../utils/Utils";

/**
 * @class GeocercaDataService
 * @brief Gestiona las operaciones de acceso a los datos de geocercas.
 */

class GeocercaDataService{
  
    /**
     * @brief Obtiene la lista de todas las geocercas registradas.
     *
     * @returns {Promise<AxiosResponse<any>>} Respuesta HTTP con las geocercas registradas.
     */
    getAll() {
        return http.get(`${getServidor()}/geocercas/`); //listado de geocercas
    }
    /**
     * @brief Crea una nueva geocerca.
     *
     * @param data Datos de la geocerca que se desea crear.
     * @param key Clave utilizada para realizar la operación de encriptación.
     *
     * @returns {Promise<AxiosResponse<any>>} Respuesta HTTP con el resultado de la operación de creación.
     */
    async create(data, key){
      const datosEncriptados = await Crypto.encriptar(data, key);
      return http.post(`${getServidor()}/geocercas/`, datosEncriptados);
    }

    /**
     * @brief Actualiza los datos de una geocerca existente.
     *
     * @param data Datos de la geocerca que se desea actualizar.
     * @param key Clave utilizada para realizar la operación de encriptación.
     *
     * @returns {Promise<AxiosResponse<any>>} Respuesta HTTP con el resultado de la operación de actualización.
     */
    async update(data, key){
      const datosEncriptados = await Crypto.encriptar(data, key);
      return http.put(`${getServidor()}/geocercas/`, datosEncriptados)
    }
}
/**
 * Variable para exportar
 */
export default new GeocercaDataService();